import React from 'react';
import { withRouter } from 'react-router-dom';

import AppNavigation from './routes';

import AuthContextProvider from './contexts/AuthContext';

function App() {
  return (
      <AuthContextProvider>
          <AppNavigation />
      </AuthContextProvider>
  );
}

export default withRouter(App);
